import mixpanel from 'mixpanel-browser';

import { User } from '~/app/contexts/UserContext';

import { EAnalyticsEvents } from '../enums';

type MixpanelEvent = {
  event: EAnalyticsEvents;
  user?: User;
  properties?: Record<string, string | number | boolean | string[]>;
};

function fireEvent({ event, properties, user }: MixpanelEvent) {
  if (!process.env.NEXT_PUBLIC_MIXPANEL_TOKEN) {
    return;
  }
  try {
    mixpanel.track(event, {
      ...properties,
      name: user?.originalUser.name,
      globalId: user?.originalUser.globalId,
      band: user?.originalUser.band,
      zone: user?.originalUser.zone,
      isManager: user?.originalUser.roles?.isManager,
      isSuperAdmin: user?.originalUser.roles?.isSuperAdmin,
      isGlobalAdmin: user?.originalUser.roles?.isGlobalAdmin,
      isZoneAdmin: user?.originalUser.roles?.isZoneAdmin,
      isPBP: user?.originalUser.roles?.isPBP,
      isTalentManager: user?.originalUser.roles?.isTalentManager,
      isProxied: user?.isProxied,
      userProxied: user?.isProxied
        ? {
            name: user?.name,
            globalId: user?.globalId,
          }
        : null,
    });
  } catch (err) {
    console.error(err);
  }
}

export const mixPanel = {
  fireEvent,
};
